import './BeautifulBuilder.less'
import useHistory from '@/hooks/useHistory'

const BeautifulBuilder = () => {
  
  const history = useHistory()
  const toDetail = (id) => {
    history.push('/WorkerMienDetail?id=' + id, 'route')
  }
  return (
    <div className="pg-beautiful-builder">
      <div className='header-wrap'>
        <img src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/beautifulBuilder/header.png' />
      </div>
      <div className='container'>
        {
          ['01','02','03','04'].map((item, index) => {
            return <img 
              key={item} 
              className='item-img' 
              src={`https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/beautifulBuilder/builder-0${index + 1}.png`} 
              onClick={() => toDetail(item)}
            />
          })
        }
      </div>
    </div>
  )
}

export default BeautifulBuilder